export default class infoCabecalho {
	id
	titulo
	subtitulo
	slotName
	isCustom
	isObrigatorio
	show
	constructor(titulo, subtitulo, slotName, isCustom = false, isObrigatorio = false, show = true) {
		this.id = `${titulo}-${Date.now()}`
		this.titulo = titulo
		this.subtitulo = subtitulo
		this.slotName = slotName
		this.isCustom = isCustom
		this.isObrigatorio = isObrigatorio
		this.show = show
	}
}
